// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/wishlist/priority.php
export default {
	name: 'collection.wishlist.priority',
	priority: 88,
	require: function(config, filter, data) {
		return filter.wishlist && (filter.wishlist.priority.from !== 1 || filter.wishlist.priority.to !== 5)
	},
	run: function(config, filter, data, query) {
		if (filter.wishlist.priority.to !== 5) {
			query.where('c.collection_wishlist_priority', '<=', filter.wishlist.priority.to)
		}
		if (filter.wishlist.priority.from !== 1) {
			query.whereGroup('OR', [
				['c.collection_wishlist_priority', '>=', filter.wishlist.priority.from],
				['c.collection_wishlist', '=', 0]
			])
		}
	}
}
